"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const RenderPhotos_1 = __importDefault(require("./RenderPhotos"));
const typography_1 = require("../../shared/typography");
const react_i18next_1 = require("react-i18next");
const useElementOnScreen_1 = require("../../shared/hooks/useElementOnScreen");
const utils_1 = require("../../molecules/utils");
const initialState = {
    isLoading: true,
    photosBase64: {
        photoFront: "",
        photoBack: "",
        photoSide: ""
    }
};
const Loading = ({ height }) => {
    return ((0, jsx_runtime_1.jsx)(LoadingWrapper, { height: height, children: (0, jsx_runtime_1.jsx)(utils_1.Loader, {}, void 0) }, void 0));
};
const LoadingWrapper = styled_components_1.default.div `
  align-items: center;
  display: flex;
  height: ${({ height }) => `${height}px`};
  justify-content: center;
  width: 100%;

  div div {
    transform: translateY(-1rem);
  }
`;
const ImagesContainer = ({ photos, onSetActiveElement, activePhotos, hasParentChildren, imgHeight, getPhotosToBase64 }) => {
    const [elementRef, isVisible] = (0, useElementOnScreen_1.useElementOnScreen)();
    const [state, setState] = (0, react_1.useState)(initialState);
    (0, react_1.useEffect)(() => {
        const fetchPhotos = async () => {
            const photosBase64 = await getPhotosToBase64(photos.photos);
            setState({
                isLoading: false,
                photosBase64
            });
        };
        if (isVisible && state.isLoading) {
            fetchPhotos();
        }
    }, [isVisible]);
    return ((0, jsx_runtime_1.jsx)("div", { ref: elementRef, children: state.isLoading ? ((0, jsx_runtime_1.jsx)(Loading, { height: imgHeight }, void 0)) : ((0, RenderPhotos_1.default)({ ...photos, photos: state.photosBase64 }, onSetActiveElement, activePhotos, !hasParentChildren)) }, void 0));
};
const WeekGroup = ({ photos, onSetActiveElement, activePhotos, getPhotosToBase64, children }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const imageContainerRef = (0, react_1.useRef)(null);
    const [imgHeight, setImgHeight] = (0, react_1.useState)(0);
    (0, react_1.useEffect)(() => {
        var _a;
        const oneImgWidth = ((((_a = imageContainerRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth) || 0) - 2 * 8) / 3; // 8px one gap, 3 images in one row
        const imgRatio = 1.5625;
        setImgHeight(oneImgWidth * imgRatio);
    }, []);
    return ((0, jsx_runtime_1.jsxs)(Wrapper, { children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(typography_1.H2, { children: `${t("measurement.week")} ${photos.week}` }, void 0), (0, jsx_runtime_1.jsx)(typography_1.P, { children: photos.createdAt }, void 0)] }, void 0), (0, jsx_runtime_1.jsx)("div", { ref: imageContainerRef, children: imgHeight && ((0, jsx_runtime_1.jsx)(ImagesContainer, { photos: photos, activePhotos: activePhotos, hasParentChildren: !!children, onSetActiveElement: onSetActiveElement, imgHeight: imgHeight, getPhotosToBase64: getPhotosToBase64 }, void 0)) }, void 0), children] }, void 0));
};
const Wrapper = styled_components_1.default.div `
  background-color: ${({ theme }) => theme.colors.whiteBase};
  border-bottom: 1px solid ${({ theme }) => theme.colors.silverBase};
  border-top: 1px solid ${({ theme }) => theme.colors.silverBase};
  margin-bottom: ${({ theme }) => theme.spacings.xs};
  padding: ${({ theme }) => theme.spacings.m};

  & > div:first-of-type {
    display: flex;
    justify-content: space-between;

    & > p {
      font-size: 0.875rem;
    }
  }

  & > div:nth-of-type(2) > div {
    display: flex;
    gap: ${({ theme }) => theme.spacings.xs};
  }
`;
exports.default = WeekGroup;
//# sourceMappingURL=WeekGroup.js.map